import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { DonationModule } from './donation/donation.module';
import { environment } from '../environments/environment';
import * as Sentry from "@sentry/angular";

Sentry.init({
    dsn: "https://6aa310e577054e8b935225d35ebde37d@sentry.twingle.de/1",
    integrations: [Sentry.captureConsoleIntegration({levels: ['error']})],
    ignoreErrors: [
        'Non-Error exception captured',
        'Non-Error promise rejection captured'
    ]
});

if (environment.production) {
    enableProdMode();
}

platformBrowserDynamic().bootstrapModule(DonationModule)
    .then(success => console.log(`Bootstrap success`))
    .catch(err => console.error(err));
